import React, { Component } from 'react';

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './RichTextEditor.css';

class RichTextEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            hasInitialized: false
        };
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
    }

    componentDidMount() {
        // Small delay to allow parent component to finish rendering
        setTimeout(() => {
            this.initializeContent();
        }, 10);
    }

    componentDidUpdate(prevProps) {
        // Handle cases where initialContent changes (like in edit mode when API data loads)
        if (this.props.initialContent !== prevProps.initialContent) {
            console.log('InitialContent changed:', {
                prev: prevProps.initialContent?.substring(0, 50) || 'empty',
                current: this.props.initialContent?.substring(0, 50) || 'empty'
            });
            
            // If we get new content and haven't initialized, or content changes from empty to having value
            if (!this.state.hasInitialized || (!prevProps.initialContent && this.props.initialContent)) {
                setTimeout(() => {
                    this.initializeContent();
                }, 10);
            }
        }
    }

    initializeContent = () => {
        const { initialContent } = this.props;
        
        if (initialContent && initialContent.trim()) {
            try {
                const { contentBlocks, entityMap } = htmlToDraft(initialContent);
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                this.setState({
                    editorState: EditorState.createWithContent(contentState),
                    hasInitialized: true
                });
                console.log('RichTextEditor initialized with content:', initialContent.substring(0, 50));
            } catch (error) {
                console.error('Error parsing HTML content:', error);
                this.setState({
                    editorState: EditorState.createEmpty(),
                    hasInitialized: true
                });
            }
        } else {
            this.setState({ 
                editorState: EditorState.createEmpty(),
                hasInitialized: true 
            });
        }
    }

    onEditorStateChange = (editorState) => {
        this.setState({ editorState });
        
        try {
            const rawContentState = convertToRaw(editorState.getCurrentContent());
            const markup = draftToHtml(rawContentState);
            
            if (this.props.onEditorContentChange) {
                this.props.onEditorContentChange(markup);
            }
        } catch (error) {
            console.error('Error converting content:', error);
        }
    };

    render() {
        const { className, hideToolbar } = this.props;
        
        return (
            <div>
                <Editor
                    className="w-100"
                    editorState={this.state.editorState}
                    wrapperClassName={className || 'rich-editor-wrapper'}
                    editorClassName="rich-editor"
                    onEditorStateChange={this.onEditorStateChange}
                    toolbarClassName={hideToolbar ? 'hide-toolbar' : ''}
                    toolbar={{
                        options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'history'],
                        inline: {
                            inDropdown: false,
                            options: ['bold', 'italic', 'underline'],
                        },
                        blockType: {
                            inDropdown: true,
                            options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
                        },
                        list: {
                            inDropdown: false,
                            options: ['unordered', 'ordered'],
                        },
                    }}
                    placeholder="Enter description..."
                    stripPastedStyles={false}
                    handlePastedText={() => false}
                    textDirectionality="LTR"
                    spellCheck={true}
                    readOnly={false}
                    tabIndex={1}
                />
            </div>
        );
    }
}

export default RichTextEditor;
